import React from "react";

// Components
import { faNotes } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import IconButton from "../Button/Icon/IconButton";

const MemberNotesLink = ({ user }: any) => {
  const { t } = useTranslation();
  return <IconButton icon={faNotes} disabled={user?.notes?.length < 1 && true} tooltip={t("notes")} align="left" routerLink={`/admin/members/${user.id}#sidebarSegment=notes`} />;
};

export default MemberNotesLink;
